import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    bankStatements: {
      description:
        'Monthly statement showing balance at the start and end of the month',
      title: 'Bank statements',
    },
    invoices: {
      description: 'Quotes and invoices you have issued in this period',
      title: 'Sales and services',
    },
    receipts: {
      description: 'Vouchers related to outgoing transactions',
      title: 'Receipts',
    },
    transactions: {
      description:
        'Table with date, transaction type, credit and debit, balance, description and name of the vouchers',
      title: 'Transactions (CSV, QIF and OFX)',
    },
  },
  fr: {
    bankStatements: {
      description:
        'Relevés mensuels indiquant les soldes en début et fin de mois',
      title: 'Relevés bancaires',
    },
    invoices: {
      description: 'Devis et factures que vous avez émis lors de la période',
      title: 'Ventes et prestations',
    },
    receipts: {
      description: 'Justificatifs associés aux transactions sortantes',
      title: 'Reçus',
    },
    transactions: {
      description:
        'Tableau incluant date, type de transaction, crédit et débit, solde bancaire, libellé et nom des justificatifs',
      title: 'Transactions (CSV, QIF et OFX)',
    },
  },
});

export default locales;
